import { c as _c } from "react/compiler-runtime";
import { useRedirectParam } from './useRedirectParam';
function isSameOriginPath(path: string): boolean {
  if (!path.startsWith('/')) return false;
  try {
    return new URL(path, window.location.origin).origin === window.location.origin;
  } catch {
    return false;
  }
}
export function useRedirectAfterLogin() {
  const $ = _c(2);
  const redirect = useRedirectParam();
  let t0;
  if ($[0] !== redirect) {
    t0 = function () {
      window.location.assign(redirect != null && isSameOriginPath(redirect) ? redirect : "/");
    };
    $[0] = redirect;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}